// extracted by mini-css-extract-plugin
export var closeButton = "_ln-1";
export var closeX = "_ln-3";
export var container = "_ln-0";
export var image = "_ln-2";